import React from 'react';
import { Card, Row, Col, Statistic, Typography, Space } from 'antd';
import {
  SafetyOutlined,
  FileProtectOutlined,
  SearchOutlined,
  WarningOutlined,
  AuditOutlined,
  UserOutlined,
  SafetyCertificateOutlined,
  RightOutlined,
} from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

const { Title, Text, Paragraph } = Typography;

export const QualityComplianceDashboard: React.FC = () => {
  const navigate = useNavigate();

  const modules: Array<{ title: string; icon: React.ReactNode; description: string; stats?: { label: string; value: number }; path: string }> = [
    {
      title: 'Quality Plans',
      icon: <FileProtectOutlined style={{ fontSize: '32px', color: '#145A54' }} />,
      description: 'Manage quality plans and standards',
      stats: { label: 'Active Plans', value: 12 },
      path: '/quality/quality-plans',
    },
    {
      title: 'Inspections',
      icon: <SearchOutlined style={{ fontSize: '32px', color: '#52c41a' }} />,
      description: 'Track quality inspections and checks',
      stats: { label: 'Pending', value: 8 },
      path: '/quality/inspections',
    },
    {
      title: 'NCRs',
      icon: <WarningOutlined style={{ fontSize: '32px', color: '#ff4d4f' }} />,
      description: 'Non-conformance reports management',
      stats: { label: 'Open NCRs', value: 5 },
      path: '/qms/ncrs',
    },
    {
      title: 'CAPAs',
      icon: <SafetyOutlined style={{ fontSize: '32px', color: '#fa8c16' }} />,
      description: 'Corrective and preventive actions',
      stats: { label: 'Active CAPAs', value: 15 },
      path: '/qms/capas',
    },
    {
      title: 'Audits',
      icon: <AuditOutlined style={{ fontSize: '32px', color: '#722ed1' }} />,
      description: 'Schedule and track quality audits',
      stats: { label: 'This Quarter', value: 6 },
      path: '/quality/audits',
    },
    {
      title: 'Risk Assessments',
      icon: <WarningOutlined style={{ fontSize: '32px', color: '#eb2f96' }} />,
      description: 'Identify and mitigate risks',
      stats: { label: 'Assessments', value: 23 },
      path: '/grc/risk-assessments',
    },
    {
      title: 'Competency & Training',
      icon: <UserOutlined style={{ fontSize: '32px', color: '#13c2c2' }} />,
      description: 'Job descriptions, training schedule, attendance, effectiveness and assessments',
      path: '/grc/competency',
    },
    {
      title: 'Compliance',
      icon: <SafetyCertificateOutlined style={{ fontSize: '32px', color: '#145A54' }} />,
      description: 'Regional compliance & e-invoicing',
      stats: { label: 'Requirements', value: 4 },
      path: '/compliance/uae-einvoicing',
    },
  ];

  return (
    <div>
      <Space direction="vertical" size="large" style={{ width: '100%' }}>
        <div>
          <Title level={2}>Quality & Compliance</Title>
          <Paragraph type="secondary">
            Manage quality, risk, compliance and regulatory requirements
          </Paragraph>
        </div>

        <Row gutter={[24, 24]}>
          {modules.map((module, index) => (
            <Col xs={24} md={12} lg={8} key={index}>
              <Card
                hoverable
                onClick={() => navigate(module.path)}
                style={{ height: '100%' }}
              >
                <Space direction="vertical" size="middle" style={{ width: '100%' }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                    {module.icon}
                    <RightOutlined style={{ color: '#8c8c8c' }} />
                  </div>
                  <div>
                    <Title level={4} style={{ marginBottom: 8 }}>{module.title}</Title>
                    <Text type="secondary">{module.description}</Text>
                  </div>
                  {module.stats && (
                    <Statistic
                      title={module.stats.label}
                      value={module.stats.value}
                      valueStyle={{ fontSize: '24px', fontWeight: 'bold' }}
                    />
                  )}
                </Space>
              </Card>
            </Col>
          ))}
        </Row>
      </Space>
    </div>
  );
};

